import { Component, EventEmitter, OnInit, ElementRef, Output, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SidebarStateService } from "src/app/services/sidebar-state.service";
import { CommonService } from "src/app/services/common.service";
import { ChatService } from "src/app/services/chat.service";
import { environment } from "src/environments/environment";
import { FileuploadService } from "src/app/services/fileupload.service";
import { Session } from "protractor";

declare var $: any;
declare const closeAllSockets: any;
declare function googleTranslate(): any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  @Output() superMaduleEvent = new EventEmitter<any>();
  roleName: string = localStorage.getItem("RoleName") || "";
  userName: string =
    (localStorage.getItem("Username")?.toUpperCase() || "") +
    " " + (sessionStorage.getItem("lastname")?.toUpperCase() || "");
  applicantId = localStorage.getItem("IsApplicant");
  table: Array<any> = [];
  viewMsg: Array<any> = [];
  message: Array<any> = [];
  levelUpdate: any;
  notifications: Array<any> = [];
  notification: any;
  viewNoti: Array<any> = [];
  OPERATION: any;
  ROLEID = localStorage.getItem("RoleId");
  myForm: any = UntypedFormGroup;
  oldPassword: any;
  chatMessage: any = "";
  chatMessagesList: any = [];
  differnceTime: any;
  startTime: any = new Date();
  endtime: any = new Date();
  patient_id: any;
  existingsname: any;
  studentArray: any = [];
  student_id: any;
  property: string = "";
  TeachersCount: any;
  onlineTeachers: any;
  notificationCount: any;
  loginDetails: any = {
    member: "Student",
    trainer: "Trainer",
    admin: "Admin",
    admin1: "Administrator L1",
    admin2: "Administrator L2",
    applicantMember: "Applicant",
  };
  isExpanded: boolean = false;
  isWaterAnimationActive: boolean = false;
  userDetails: any;
  url: string = environment.videoUrl;
  roles: Array<any> = [];
  selectRole: string = "";
  selectedModule: any = "1";
  profileDetails: any = "";
  previewUrl: any;
  file: any = File;
  fileName: string = "";
  imageName: string = "";
  @ViewChild("fileInputRef") fileInputRef: any = ElementRef;
  @ViewChild("fileInputRef1") fileInputRef1: any = ElementRef;
  SchoolList: Array<any> = [];
  SchoolLevelId = localStorage.getItem("schoolLevelID") || 0;
  dashboardPath: any = sessionStorage.getItem("dashboard_path");

  // Edit Institution Properties
  editData: any = {};
  originalData: any = {};
  isUpdating: boolean = false;
  userId: number = parseInt(localStorage.getItem("UserId") || "0");
  County: Array<any> = [];
  ApplicationType: Array<any> = [];
  subCounty: Array<any> = [];
  Constituency: Array<any> = [];
  categories: any[] = [];
  sneCategoriesList: any[] = [];
  selectedSneDetails: any[] = [];
  subSneCategoriesList: any[] = [];
  selectedSubSneDetails: any[] = [];
  showSubSneDropdown: boolean = false;
  updateLogs: any[] = [];

  // Stored values for institution type change
  storedBoysCapacity: number = 0;
  storedSneBoysCapacity: number = 0;
  storedGirlsCapacity: number = 0;
  storedSneGirlsCapacity: number = 0;
  previousInstitutionType: number = 0;

  // File upload
  certificateFileToUpload: File | null = null;
  InstitutionRegCertificate: string = "";

  dropdownSettings: any = {};
  subDropdownSettings: any = {};

  // Flags for preventing selection changes
  private isRevertingSelection: boolean = false;
  private originalSneDetails: any[] = [];
  private originalSubSneDetails: any[] = [];
  activeTab: string = 'details';

  // Change detection flag
  hasChanges: boolean = false;

  // Flag to prevent change detection during email validation
  private isEmailValidationInProgress: boolean = false;

  // Track original values for comparison
  private originalFormValues: any = {};

  // Track which fields have been touched for validation display
  touchedFields: { [key: string]: boolean } = {};

  studentCount: number = 0;
  isStudentCountGreaterThanZero: boolean = false;
  firstname: string = "";
  constructor(
    private route: Router,
    private chatService: ChatService,
    private CommonService: CommonService,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private sidebarStateService: SidebarStateService,
    private FileuploadService: FileuploadService,
  ) {
    this.CommonService.decrypt$(
      localStorage.getItem("RoleId") || "0",
    ).subscribe((value) => {
      this.ROLEID = value;
    });

    this.sidebarStateService.isExpanded$.subscribe((isExpanded) => {
      this.isExpanded = isExpanded;
    });

    if (this.ROLEID == "3") {
      if (this.applicantId === "1") {
        this.roleName = this.loginDetails.applicantMember;
      } else {
        this.roleName = this.loginDetails.member;
      }
    } else if (this.ROLEID == "2") {
      this.roleName = this.loginDetails.trainer;
    } else if (this.ROLEID == "1") {
      this.roleName = this.loginDetails.admin;
    } else if (this.roleName == "Academic L1") {
      this.roleName = this.loginDetails.admin1;
    } else if (this.roleName == "Academic L2") {
      this.roleName = this.loginDetails.admin2;
    }
  }

  async decryptionRoleId() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId") as any,
      this.CommonService.secretKey,
    );
    this.decryptionRoleId = decryptedValue;
  }

  private iniForm() {
    this.myForm = this.fb.group({
      oldPassword: ["", [Validators.required, Validators.minLength(6)]],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
        ],
      ],
      confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit() {
    this.decryptionRoleId();
    this.iniForm();

    // Initialize dropdown settings
    this.dropdownSettings = {
      singleSelection: false,
      idField: "SNE_CATEGORY_ID",
      textField: "SNE_CATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
      limitSelection: -1,
      badgeShowLimit: 3,
    };

    this.subDropdownSettings = {
      singleSelection: false,
      idField: "SNE_SUBCATEGORY_ID",
      textField: "SNE_SUBCATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
      limitSelection: -1,
      badgeShowLimit: 3,
    };

    this.CommonService.decrypt$(
      localStorage.getItem("RoleId") || "0",
    ).subscribe((value) => {
      this.selectedModule = value;
    });
    this.superMaduleEvent.emit(this.selectedModule);
    this.loadingToggled();
    // this.getUserProfile();
    this.getRoles();
    if (![1, 2, 3, 4, 9, 10].includes(Number(this.ROLEID))) {
      this.getSchool();
    }
  }

  /**
   * Check if the form is valid - all mandatory fields are filled
   */
  isFormValid(): boolean {
    // Check Institution Name
    if (!this.editData.TNT_NAME || this.editData.TNT_NAME.trim() === '') {
      return false;
    }

    // Check Email
    if (!this.editData.email || this.editData.email.trim() === '') {
      return false;
    }

    // Check Mobile Number
    if (!this.editData.mobileno || this.editData.mobileno.trim() === '') {
      return false;
    }

    // Check Application Type (School Category)
    if (!this.editData.school_category_id ||
      this.editData.school_category_id === '' ||
      this.editData.school_category_id === '0') {
      return false;
    }

    // Check if SNE Categories are required (when school_category_id is 2, 3, or 4)
    const categoryId = this.editData.school_category_id?.toString();
    if (categoryId && ['2', '3', '4'].includes(categoryId)) {
      if (!this.selectedSneDetails || this.selectedSneDetails.length === 0) {
        return false;
      }
    }

    return true;
  }

  /**
   * Check if a specific field has an error
   */
  hasFieldError(fieldName: string): boolean {
    if (fieldName === 'TNT_NAME') {
      return !this.editData.TNT_NAME || this.editData.TNT_NAME.trim() === '';
    }
    if (fieldName === 'email') {
      return !this.editData.email || this.editData.email.trim() === '';
    }
    if (fieldName === 'mobileno') {
      return !this.editData.mobileno || this.editData.mobileno.trim() === '';
    }
    if (fieldName === 'school_category_id') {
      return !this.editData.school_category_id ||
        this.editData.school_category_id === '' ||
        this.editData.school_category_id === '0';
    }
    if (fieldName === 'sne_categories') {
      const categoryId = this.editData.school_category_id?.toString();
      if (categoryId && ['2', '3', '4'].includes(categoryId)) {
        return !this.selectedSneDetails || this.selectedSneDetails.length === 0;
      }
      return false;
    }
    return false;
  }

  /**
   * Mark a field as touched
   */
  markFieldAsTouched(fieldName: string) {
    this.touchedFields[fieldName] = true;
  }

  async ConvertRoleId() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId") || "0",
      this.CommonService.secretKey,
    );
    this.ROLEID = decryptedValue;
  }

  getUserProfile() {
    this.CommonService.postCall("Registration/GetAudioPath", {
      USERID: localStorage.getItem("UserId"),
      COURSE_ID: localStorage.getItem("CourseId"),
    }).subscribe((res: any) => {
      this.userDetails = res;
    });
  }

  loadProfileLogo() {
    this.CommonService.getCall(
      `TenantRegistration/GetProfileScreenForInstitutes/${localStorage.getItem("TenantCode")}`,
    ).subscribe((res: any) => {
      this.profileDetails = res;
      this.fileName = this.profileDetails?.tnt_logo;
      this.previewUrl = this.getImage();
    });
  }

  LoadProfileDetails() {
    this.activeSpinner();
    // Load county dropdowns first
    this.countyDropdowns();
    this.ApplicationDropdowns();
    this.loadProfileLogo();
    if (this.ROLEID == "1") {
      this.profileDetails = "";
      this.CommonService.getCall(
        `TenantRegistration/GetProfileScreenForInstitutes/${localStorage.getItem("TenantCode")}`,
      ).subscribe((res: any) => {
        this.profileDetails = res;
        this.fileName = this.profileDetails.tnt_logo;
        this.previewUrl = this.getImage();
        // Load institution data after county dropdowns are loaded
        this.loadInstitutionForEdit();
        this.deactivateSpinner();
      }, (e) => {
        this.deactivateSpinner();
      });
    }
  }

  loadInstitutionForEdit() {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantbyId", {
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.editData = JSON.parse(JSON.stringify(res));
        this.originalData = JSON.parse(JSON.stringify(res));
        this.editData.firstname = res.firstname || '';

        // IMPORTANT: Get student count from response
        this.studentCount = res.student_count || 0;
        this.isStudentCountGreaterThanZero = this.studentCount > 0;

        // Initialize stored values
        this.storedBoysCapacity = this.editData.tnt_boys_capacity || 0;
        this.storedSneBoysCapacity = this.editData.tnt_sne_boyscapacity || 0;
        this.storedGirlsCapacity = this.editData.tnt_girls_capacity || 0;
        this.storedSneGirlsCapacity = this.editData.tnt_sne_girlscapacity || 0;
        this.previousInstitutionType = this.editData.institution_type || 0;

        this.initializeEditDataDefaults();
        this.getSchoolCategories();

        // Load County, Sub County, and Constituency data
        this.loadLocationData();

        if (
          this.editData.school_category_id &&
          ["2", "3", "4"].includes(this.editData.school_category_id.toString())
        ) {
          this.getSneCategoryList(this.editData.school_category_id.toString());
        }

        this.calculateTotalLearners();
        this.deactivateSpinner();

        // Store original form values for comparison
        this.captureOriginalFormValues();

        // Reset change detection flag
        this.hasChanges = false;

        // Reset touched fields
        this.touchedFields = {};

        setTimeout(() => {
          $("#editInstitutionModal").modal("show");
        }, 100);
      },
      (e) => {
        this.deactivateSpinner();
        this.toastr.error("Failed to load institution data for editing");
      },
    );
  }

  /**
   * Load location data (County, Sub County, Constituency)
   */
  loadLocationData() {
    // Set County dropdown
    const countyId = this.editData.TNT_CONCURRENT_AVSESSIONS;
    if (countyId && countyId != 0) {
      // Ensure County dropdown is loaded
      if (this.County.length === 0) {
        this.countyDropdowns();
      }
      // this.ApplicationDropdowns();
      // Load Sub County and Constituency based on County ID
      this.subCounties(countyId);
    }
  }

  /**
   * Check if institution level dropdown should be disabled
   * Returns true if there are students enrolled (student_count > 0)
   */
  isInstitutionLevelDisabled(): boolean {
    return this.isStudentCountGreaterThanZero;
  }

  captureOriginalFormValues() {
    this.originalFormValues = {
      TNT_NAME: this.editData.TNT_NAME || '',
      email: this.editData.email || '',
      mobileno: this.editData.mobileno || '',
      institution_type: this.editData.institution_type || '',
      tnt_boys_capacity: this.editData.tnt_boys_capacity || 0,
      tnt_girls_capacity: this.editData.tnt_girls_capacity || 0,
      tnt_sne_boyscapacity: this.editData.tnt_sne_boyscapacity || 0,
      tnt_sne_girlscapacity: this.editData.tnt_sne_girlscapacity || 0,
      tnt_sne_capacity: this.editData.tnt_sne_capacity || 0,
      school_category_id: this.editData.school_category_id || '',
      TNT_CONCURRENT_AVSESSIONS: this.editData.TNT_CONCURRENT_AVSESSIONS || '',
      TNT_USERSPERSESSION: this.editData.TNT_USERSPERSESSION || '',
      constituency: this.editData.constituency || '',
      schoollevel: this.editData.schoollevel || '',
      student_count: this.studentCount || 0
    };
  }

  initializeEditDataDefaults() {
    const defaults = {
      TNT_NAME: "",
      TNT_DESCRIPTION: "",
      TNT_CONCURRENT_AVSESSIONS: "",
      TNT_USERSPERSESSION: "",
      email: "",
      mobileno: "",
      schoollocation: "",
      schoollevel: "",
      TNT_PARENT_CODE: null,
      SHOWLOGO: false,
      allow_proctoring: false,
      allow_exampad: false,
      constituency: "",
      simba_acc: "",
      gpa_accno: "",
      bankbranch: "",
      bankname: "",
      noofnonteaching_female: 0,
      noofnonteaching_male: 0,
      noofteaching_female: 0,
      noofteaching_male: 0,
      noofteaching_total: 0,
      noofnonteaching_total: 0,
      learnerenrolment_total: 0,
      accommodation_type: "",
      gpi: "0",
      landmark: "",
      applicationtype: "",
      registration_no: "",
      tnt_sne_capacity: 0,
      tnt_registration_certificate: "",
      tnt_boys_capacity: 0,
      tnt_girls_capacity: 0,
      tnt_sne_boyscapacity: 0,
      tnt_sne_girlscapacity: 0,
      school_regno: "",
      enrollment_boys: 0,
      enrollment_girls: 0,
      schoolnameincertificate: "",
      latitude: "",
      longitude: "",
      sne_disabilitytype_otherdescription: "",
      reregistration_reasons: 0,
      institution_type: "",
      subscriptionid: 35,
      mobilenocode_countryid: "336",
      mobilenocode_countryName: null,
      is_valid_certificate: false,
      TNT_CREATEDBY: null,
      TNT_KEY: "",
      school_category_id: "",
      sne_category_id: "",
      sne_subcategory_id: "",
      registration_type: 1,
      TNT_STATUS: true,
      TenantLogoUrl: "",
      institution_level: "",
      counties_id: 0,
      sub_counties_name: "",
      counties_name: "",
      con_counties_name: "",
      TNT_MODIFIEDBY: this.userId,
      TNT_CODE: localStorage.getItem("TenantCode") || "",
    };

    for (const key in defaults) {
      if (this.editData[key] === undefined || this.editData[key] === null) {
        this.editData[key] = defaults[key];
      }
    }
  }

  countyDropdowns() {
    this.County = [];
    this.CommonService.postCall("ClustersMaster/GetCountiesListByKenya", {
      COUNTRY_NAME: "Kenya",
    }).subscribe(
      (res: any) => {
        this.County = res;
        this.County = this.County.filter((x) => x.STATUS == true);
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No County's found!");
      },
    );
  }
  ApplicationDropdowns() {
    this.ApplicationType = [];
    this.CommonService.postCall("TenantRegistration/GetActiveApplicationType", {
      tnt_code: 90076444,
    }).subscribe(
      (res: any) => {
        this.ApplicationType = res;
        // this.County = this.County.filter((x) => x.STATUS == true);
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No Application Type's found!");
      },
    );
  }

  subCounties(SubCountyId: any) {
    this.subCounty = [];
    this.Constituency = [];

    this.CommonService.postCall("ClustersMaster/GetSubCountiesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.subCounty = res;
        // After loading sub-counties, set the selected sub-county
        this.setSelectedSubCounty();
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Sub-County's found!");
      },
    );

    this.CommonService.postCall("ClustersMaster/GetCountyconstituenciesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.Constituency = res;
        // After loading constituencies, set the selected constituency
        this.setSelectedConstituency();
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Constituency found!");
      },
    );
  }

  /**
   * Set the selected sub-county after loading the list
   */
  setSelectedSubCounty() {
    const savedSubCountyId = this.editData.TNT_USERSPERSESSION;
    if (savedSubCountyId && this.subCounty.length > 0) {
      // Find the sub-county in the list
      const found = this.subCounty.find(
        (item: any) => item.sub_counties_id == savedSubCountyId ||
          item.sub_counties_name == savedSubCountyId
      );
      if (found) {
        this.editData.TNT_USERSPERSESSION = found.sub_counties_id;
      } else {
        // If not found, try to find by name
        const foundByName = this.subCounty.find(
          (item: any) => item.sub_counties_name == savedSubCountyId
        );
        if (foundByName) {
          this.editData.TNT_USERSPERSESSION = foundByName.sub_counties_id;
        }
      }
    }
  }

  /**
   * Set the selected constituency after loading the list
   */
  setSelectedConstituency() {
    const savedConstituency = this.editData.constituency;
    if (savedConstituency && this.Constituency.length > 0) {
      // Find the constituency in the list
      const found = this.Constituency.find(
        (item: any) => item.con_counties_id == savedConstituency ||
          item.con_counties_name == savedConstituency
      );
      if (found) {
        this.editData.constituency = found.con_counties_id;
      } else {
        // If not found, try to find by name
        const foundByName = this.Constituency.find(
          (item: any) => item.con_counties_name == savedConstituency
        );
        if (foundByName) {
          this.editData.constituency = foundByName.con_counties_id;
        }
      }
    }
  }

  getSchoolCategories() {
    this.categories = [];
    this.CommonService.postCall(
      "TenantRegistration/GetSchoolCategoryList",
      {},
    ).subscribe(
      (res: any) => {
        this.categories = res;
      },
      (err: any) => {
        console.error("Error loading categories:", err);
      },
    );
  }

  getSneCategoryList(categoryId: string) {
    this.activeSpinner();
    this.sneCategoriesList = [];
    this.selectedSneDetails = [];

    this.CommonService.postCall("TenantRegistration/GetSneCategoryList", {
      SCHOOL_CATEGORY_ID: categoryId,
    }).subscribe(
      (res: any) => {
        this.sneCategoriesList = res;
        if (this.editData?.sne_category_id) {
          const existingIds = this.editData.sne_category_id.split(",");
          this.selectedSneDetails = this.sneCategoriesList.filter((item: any) =>
            existingIds.includes(item.SNE_CATEGORY_ID.toString()),
          );
          // Store original selections for read-only protection
          this.originalSneDetails = JSON.parse(
            JSON.stringify(this.selectedSneDetails),
          );
          this.onSneDetailChange();
        }
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
        console.error("Error loading SNE categories:", err);
      },
    );
  }

  getSubSneCategoryList(categoryIds: number[]) {
    this.activeSpinner();
    this.subSneCategoriesList = [];

    this.CommonService.postCall("TenantRegistration/GetSubSneCategoryList", {
      SNE_CATEGORY_IDS: categoryIds.join(","),
    }).subscribe(
      (res: any) => {
        this.subSneCategoriesList = res;
        if (this.editData?.sne_subcategory_id) {
          const existingSubIds = this.editData.sne_subcategory_id.split(",");
          this.selectedSubSneDetails = this.subSneCategoriesList.filter(
            (item: any) =>
              existingSubIds.includes(item.SNE_SUBCATEGORY_ID.toString()),
          );
          // Store original selections for read-only protection
          this.originalSubSneDetails = JSON.parse(
            JSON.stringify(this.selectedSubSneDetails),
          );
        }
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
        console.error("Error loading sub categories:", err);
      },
    );
  }

  // Check if any changes have been made to the form
  checkForChanges() {
    // Don't check during email validation to prevent false positives
    if (this.isEmailValidationInProgress) {
      return;
    }

    if (!this.originalFormValues || !this.editData) {
      this.hasChanges = false;
      return;
    }

    // Compare all editable fields
    const fieldsToCompare = [
      'TNT_NAME',
      'email',
      'mobileno',
      'institution_type',
      'tnt_boys_capacity',
      'tnt_girls_capacity',
      'tnt_sne_boyscapacity',
      'tnt_sne_girlscapacity',
      'tnt_sne_capacity',
      'school_category_id',
      'TNT_CONCURRENT_AVSESSIONS',
      'TNT_USERSPERSESSION',
      'constituency',
      'schoollevel'
    ];

    let hasChanges = false;
    let changedFields = [];

    for (const field of fieldsToCompare) {
      const originalValue = this.originalFormValues[field] !== undefined ? this.originalFormValues[field] : '';
      const currentValue = this.editData[field] !== undefined ? this.editData[field] : '';

      // Convert to string for comparison to handle number/string differences
      if (originalValue.toString() !== currentValue.toString()) {
        hasChanges = true;
        changedFields.push(`${field}: "${originalValue}" -> "${currentValue}"`);
        break;
      }
    }

    // Check SNE selections if applicable
    if (!hasChanges && this.selectedSneDetails.length > 0) {
      const originalSneIds = this.originalSneDetails.map((x: any) => x.SNE_CATEGORY_ID).sort();
      const currentSneIds = this.selectedSneDetails.map((x: any) => x.SNE_CATEGORY_ID).sort();
      if (JSON.stringify(originalSneIds) !== JSON.stringify(currentSneIds)) {
        hasChanges = true;
        changedFields.push('SNE categories changed');
      }
    }

    // Check Sub SNE selections if applicable
    if (!hasChanges && this.selectedSubSneDetails.length > 0) {
      const originalSubSneIds = this.originalSubSneDetails.map((x: any) => x.SNE_SUBCATEGORY_ID).sort();
      const currentSubSneIds = this.selectedSubSneDetails.map((x: any) => x.SNE_SUBCATEGORY_ID).sort();
      if (JSON.stringify(originalSubSneIds) !== JSON.stringify(currentSubSneIds)) {
        hasChanges = true;
        changedFields.push('Sub SNE categories changed');
      }
    }

    // Also check if SNE selections were cleared (length changed)
    if (!hasChanges) {
      const originalSneLength = this.originalSneDetails.length;
      const currentSneLength = this.selectedSneDetails.length;
      if (originalSneLength !== currentSneLength) {
        hasChanges = true;
        changedFields.push(`SNE selections length changed: ${originalSneLength} -> ${currentSneLength}`);
      }
    }

    this.hasChanges = hasChanges;
  }

  // Method to handle input changes from template
  onInputChange() {
    this.checkForChanges();
  }

  onSneDetailChange(event?: any) {
    // Process sub-category dropdown logic
    const targetIds = ["12", "13", "17"];
    const matchedIds = this.selectedSneDetails
      .map((x: any) => x.SNE_CATEGORY_ID?.toString())
      .filter((id: string) => targetIds.includes(id))
      .map((id) => +id);

    if (matchedIds.length > 0) {
      this.showSubSneDropdown = true;
      this.getSubSneCategoryList(matchedIds);
    } else {
      this.showSubSneDropdown = false;
      this.subSneCategoriesList = [];
      this.selectedSubSneDetails = [];
      this.originalSubSneDetails = [];
    }

    // Check for changes after selection
    this.checkForChanges();
  }

  onSubSneDetailChange(event?: any) {
    // Check for changes after selection
    this.checkForChanges();
  }

  shouldShowIntegratedField(): boolean {
    const categoryId = this.editData?.school_category_id;
    return categoryId && ["2", "3", "4"].includes(categoryId.toString());
  }

  onCountyChange(event: any) {
    const countyId = event.target.value;
    if (countyId && countyId != 0) {
      this.subCounties(countyId);
      this.editData.TNT_CONCURRENT_AVSESSIONS = countyId;
    } else {
      this.subCounty = [];
      this.Constituency = [];
      this.editData.TNT_CONCURRENT_AVSESSIONS = '';
    }
    this.checkForChanges();
  }

  onSubCountyChange(event: any) {
    const subCountyId = event.target.value;
    this.editData.TNT_USERSPERSESSION = subCountyId;
    this.checkForChanges();
  }

  onConstituencyChange(event: any) {
    const constituencyId = event.target.value;
    this.editData.constituency = constituencyId;
    this.checkForChanges();
  }

  onSchoolCategoryChange(event: any) {
    const categoryId = event.target.value;
    if (categoryId && ["2", "3", "4"].includes(categoryId)) {
      this.getSneCategoryList(categoryId);
    } else {
      this.sneCategoriesList = [];
      this.selectedSneDetails = [];
      this.originalSneDetails = [];
      this.showSubSneDropdown = false;
      this.subSneCategoriesList = [];
      this.selectedSubSneDetails = [];
      this.originalSubSneDetails = [];
    }
    this.checkForChanges();
  }

  calculateTotalLearners() {
    const boys = parseFloat(this.editData.tnt_boys_capacity) || 0;
    const sneBoys = parseFloat(this.editData.tnt_sne_boyscapacity) || 0;
    const girls = parseFloat(this.editData.tnt_girls_capacity) || 0;
    const sneGirls = parseFloat(this.editData.tnt_sne_girlscapacity) || 0;

    const total = boys + sneBoys + girls + sneGirls;
    this.editData.tnt_sne_capacity = total;
    this.checkForChanges();
  }

  onInstitutionTypeChange() {
    const newType = this.editData.institution_type;

    if (
      this.previousInstitutionType == 1 ||
      this.previousInstitutionType == 3
    ) {
      this.storedBoysCapacity = this.editData.tnt_boys_capacity || 0;
      this.storedSneBoysCapacity = this.editData.tnt_sne_boyscapacity || 0;
    }

    if (
      this.previousInstitutionType == 2 ||
      this.previousInstitutionType == 3
    ) {
      this.storedGirlsCapacity = this.editData.tnt_girls_capacity || 0;
      this.storedSneGirlsCapacity = this.editData.tnt_sne_girlscapacity || 0;
    }

    if (newType == 1) {
      this.editData.tnt_boys_capacity = this.storedBoysCapacity;
      this.editData.tnt_sne_boyscapacity = this.storedSneBoysCapacity;
      this.editData.tnt_girls_capacity = 0;
      this.editData.tnt_sne_girlscapacity = 0;
    } else if (newType == 2) {
      this.editData.tnt_boys_capacity = 0;
      this.editData.tnt_sne_boyscapacity = 0;
      this.editData.tnt_girls_capacity = this.storedGirlsCapacity;
      this.editData.tnt_sne_girlscapacity = this.storedSneGirlsCapacity;
    } else if (newType == 3) {
      this.editData.tnt_boys_capacity = this.storedBoysCapacity;
      this.editData.tnt_sne_boyscapacity = this.storedSneBoysCapacity;
      this.editData.tnt_girls_capacity = this.storedGirlsCapacity;
      this.editData.tnt_sne_girlscapacity = this.storedSneGirlsCapacity;
    }

    this.previousInstitutionType = newType;
    this.calculateTotalLearners();
    this.checkForChanges();
  }

  changeFileForMultiple(event: any, type: number) {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      const fileSize = file.size / (1024 * 1024);

      if (fileType !== "application/pdf") {
        this.toastr.warning("File must be in PDF format only");
        if (this.fileInputRef1) {
          this.fileInputRef1.nativeElement.value = "";
        }
        return;
      }

      if (fileSize > 8) {
        this.toastr.warning("File size must be less than 8MB");
        if (this.fileInputRef1) {
          this.fileInputRef1.nativeElement.value = "";
        }
        return;
      }

      this.certificateFileToUpload = file;
      this.uploadFile(type);
    }
  }

  uploadFile(type: number) {
    if (!this.certificateFileToUpload) return;

    this.activeSpinner();

    const formData = new FormData();
    formData.append("upload_1", this.certificateFileToUpload);
    formData.append("DIRECTORY_NAME", "institutionDocuments");

    this.FileuploadService.upload(
      formData,
      "Registration/UploadTenantRegistrationFile",
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        const uploadedPath = res.path;
        this.InstitutionRegCertificate = uploadedPath;
        this.editData.tnt_registration_certificate = uploadedPath;
        this.toastr.success("File uploaded successfully");
        this.checkForChanges();
      },
      (err) => {
        this.deactivateSpinner();
        this.toastr.error("Upload Failed");
      },
    );
  }

  getFileUrl(path: string): string {
    return path;
  }

  // Load update logs for the institution
  loadUpdateLogs() {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantUpdateLogs", {
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.updateLogs = res || [];
        this.deactivateSpinner();
      },
      (err) => {
        this.deactivateSpinner();
        console.error("Error loading update logs:", err);
        this.updateLogs = [];
      },
    );
  }

  getFieldDisplayName(fieldName: string): string {
    const fieldNames: { [key: string]: string } = {
      TNT_NAME: "Institution Name",
      email: "Email",
      mobileno: "Mobile Number",
      institution_type: "Institution Type",
      tnt_boys_capacity: "Number of Boys Learners",
      tnt_girls_capacity: "Number of Girls Learners",
      tnt_sne_boyscapacity: "Number of SNE Boys",
      tnt_sne_girlscapacity: "Number of SNE Girls",
      tnt_sne_capacity: "Total Number of Learners",
      accommodation_type: "Accommodation Type",
      registration_no: "Registration Number",
      tnt_registration_certificate: "Registration Certificate",
      TNT_CONCURRENT_AVSESSIONS: "County",
      TNT_USERSPERSESSION: "Sub County",
      constituency: "Constituency",
      schoollevel: "Institution Level",
      school_category_id: "Application Type",
      applicationtype: "School Category",
      TNT_STATUS: "Status",
      sne_category_id: "Integrated Categories",
      sne_subcategory_id: "Sub Categories",
    };
    return fieldNames[fieldName] || fieldName;
  }

  updateInstitution() {
    // Validate the form before submitting
    if (!this.isFormValid()) {
      // Mark all fields as touched to show validation errors
      this.touchedFields['TNT_NAME'] = true;
      this.touchedFields['email'] = true;
      this.touchedFields['mobileno'] = true;
      this.touchedFields['school_category_id'] = true;

      // Show a toast message
      this.toastr.warning('Please fill in all required fields before submitting.');

      // Scroll to the first invalid field
      const firstInvalidField = document.querySelector('.is-invalid');
      if (firstInvalidField) {
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        (firstInvalidField as HTMLElement).focus();
      }
      return;
    }

    this.isUpdating = true;
    this.activeSpinner();

    this.calculateTotalLearners();

    // Prepare the payload matching the required structure
    const payload: any = {
      tnt_code: parseInt(localStorage.getItem("TenantCode") || this.editData.TNT_CODE || "0"),
      temp_tnt_name: this.editData.TNT_NAME || "",
      temp_email: this.editData.email || "",
      mobileno: this.editData.mobileno || "",
      is_submitted: 1,
      temp_school_category_id: parseInt(this.editData.school_category_id) || 0,
      temp_boys_capacity: Number(this.editData.tnt_boys_capacity) || 0,
      temp_sne_boyscapacity: Number(this.editData.tnt_sne_boyscapacity) || 0,
      temp_girls_capacity: Number(this.editData.tnt_girls_capacity) || 0,
      temp_sne_girlscapacity: Number(this.editData.tnt_sne_girlscapacity) || 0,
      temp_sne_capacity: Number(this.editData.tnt_sne_capacity) || 0,
      temp_createdby: parseInt(localStorage.getItem("UserId") || "0"),
      temp_modifiedby: parseInt(localStorage.getItem("UserId") || "0"),
      temp_schoollevel: this.editData.schoollevel,
      status: true
    };

    // Add SNE category IDs as comma-separated string
    if (this.selectedSneDetails && this.selectedSneDetails.length > 0) {
      payload.temp_sne_category_id = this.selectedSneDetails
        .map((x: any) => x.SNE_CATEGORY_ID)
        .join(",");
    } else if (this.editData.sne_category_id) {
      payload.temp_sne_category_id = this.editData.sne_category_id;
    } else {
      payload.temp_sne_category_id = "0";
    }

    // Add Sub SNE category IDs as comma-separated string
    if (this.selectedSubSneDetails && this.selectedSubSneDetails.length > 0) {
      payload.temp_sne_subcategory_id = this.selectedSubSneDetails
        .map((x: any) => x.SNE_SUBCATEGORY_ID)
        .join(",");
    } else if (this.editData.sne_subcategory_id) {
      payload.temp_sne_subcategory_id = this.editData.sne_subcategory_id;
    } else {
      payload.temp_sne_subcategory_id = "0";
    }

    // Call the CreateTenantTemp endpoint
    this.CommonService.postCall(
      "TenantRegistration/CreateTenantTemp",
      payload
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.isUpdating = false;
        this.toastr.success("Institution update submitted successfully");

        // Refresh profile details and logo
        this.loadProfileLogo();

        // Update original data with new values
        this.originalData = JSON.parse(JSON.stringify(this.editData));

        // Update original form values
        this.captureOriginalFormValues();

        // Reset change detection flag
        this.hasChanges = false;

        // Reset touched fields
        this.touchedFields = {};

        $("#editInstitutionModal").modal("hide");
      },
      (error) => {
        this.deactivateSpinner();
        this.isUpdating = false;
        this.toastr.error("Failed to update institution. Please try again.");
      },
    );
  }

  closeEditModal() {
    this.resetSneSelections();
    this.certificateFileToUpload = null;
    if (this.fileInputRef1) {
      this.fileInputRef1.nativeElement.value = "";
    }
    this.hasChanges = false;
    this.touchedFields = {};
    // Reset location dropdowns to prevent stale data
    this.subCounty = [];
    this.Constituency = [];
  }

  resetSneSelections() {
    this.selectedSneDetails = [];
    this.selectedSubSneDetails = [];
    this.sneCategoriesList = [];
    this.subSneCategoriesList = [];
    this.showSubSneDropdown = false;
    this.originalSneDetails = [];
    this.originalSubSneDetails = [];
  }

  validateEmail(event: any): void {
    const val = event.target.value.trim();
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

    if (!emailPattern.test(val)) {
      this.editData.email = "";
      this.toastr.warning("Invalid Email, Please Input a Valid Email Address.");
      this.checkForChanges();
      return;
    }

    const domain = val.split("@")[1];
    if (/\d/.test(domain)) {
      this.editData.email = "";
      this.toastr.warning(
        'Numbers are not allowed in the domain part of the email (after "@").',
      );
      this.checkForChanges();
      return;
    }
    this.checkForChanges();
  }

  checkEmail(event: any, ctrl: string = '') {
    // Get the email value and convert to lowercase
    let emailValue = ctrl == '' ? event?.target.value : event;

    // Convert to lowercase and trim
    if (emailValue) {
      emailValue = emailValue.toLowerCase().trim();
      // Update the model with lowercase value
      this.editData.email = emailValue;
    }

    if (!this.editData.email) {
      this.checkForChanges();
      return;
    }

    // Check if email is unchanged from original
    if (this.originalFormValues.email &&
      this.originalFormValues.email.toLowerCase().trim() === emailValue) {
      this.checkForChanges();
      return;
    }

    // Set flag to prevent change detection during validation
    this.isEmailValidationInProgress = true;
    this.activeSpinner();

    // Use the lowercase email for validation
    this.CommonService.postCall('Registration/GetIsValidEmail', {
      email: this.editData.email,
    }).subscribe(
      (res: any) => {
        if (res.message) {
          // Email exists - revert to original
          this.editData.email = this.originalFormValues.email || '';
          this.toastr.error(res.message);
        }
        this.deactivateSpinner();
        // Allow change detection after validation is complete
        this.isEmailValidationInProgress = false;
        // Check for actual changes (email should now be reverted if it was invalid)
        this.checkForChanges();
      },
      (e) => {
        if (e.error) {
          // Email exists - revert to original
          this.editData.email = this.originalFormValues.email || '';
          this.toastr.error(e.error.message || 'Email Already Exists');
        }
        this.deactivateSpinner();
        // Allow change detection after validation is complete
        this.isEmailValidationInProgress = false;
        // Check for actual changes (email should now be reverted if it was invalid)
        this.checkForChanges();
      },
    );
  }

  // Logo Upload Methods
  changeFile(event: any) {
    // Check if files exist and have length
    if (event.target.files && event.target.files.length > 0) {
      let file: File = event.target.files[0];

      // Additional check to ensure file is valid
      if (!file || file.size === 0) {
        this.file = null as any;
        event.target.value = '';
        this.toastr.warning('Invalid file selected');
        return;
      }

      let name = file.name;
      let filetype = name.split('.').pop();
      let types: Array<any> = ['png', 'jpg', 'PNG', 'jpeg', 'gif', 'JPEG'];
      let check = types.includes(filetype);

      if (check) {
        this.file = file;
        const reader = new FileReader();
        reader.onload = () => {
          this.previewUrl = reader.result;
        };
        reader.readAsDataURL(this.file);
      } else {
        alert('Please upload image file formats only.');
        event.target.value = '';
        this.file = null as any; // Reset file on invalid type
        this.previewUrl = null; // Clear preview
      }
    } else {
      // No file selected - reset everything
      this.file = null as any;
      this.previewUrl = null;
      event.target.value = '';
    }
  }

  upload() {
    // Check if file exists and is valid
    if (!this.file || !(this.file instanceof File) || this.file.size === 0) {
      this.toastr.warning('Please select a valid logo image first');
      this.file = null as any; // Reset invalid file
      return;
    }

    let base64String: any;
    var reader = new FileReader();
    let self = this;

    reader.onload = function () {
      base64String = reader.result;
      self.fileName = base64String;
      let payLoad = {
        TNT_CODE: localStorage.getItem('TenantCode'),
        Tnt_BaseLogo: self.fileName,
      };
      self.CommonService.postCall('TenantRegistration/UploadTenantLogo', payLoad).subscribe(
        (res: any) => {
          self.toastr.success('Image Saved Successfully');
          self.loadProfileLogo();
        },
        (err) => {
          self.toastr.error(err.error ? err.error : 'Image Not Updated');
        },
      );
    };
    reader.readAsDataURL(this.file);
  }

  clearFileInput() {
    this.file = null as any;
    this.previewUrl = null;
    this.fileName = '';
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
  }

  getImage() {
    if (!this.fileName) return '';
    if (this.fileName.includes('data:image')) {
      return this.fileName;
    } else {
      return 'data:image/png;base64,' + this.fileName;
    }
  }

  closeProfileInfo() {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = "";
    }
    this.file = null;
    this.fileName = "";
    this.previewUrl = null;
  }

  toggleIsExpanded() {
    this.sidebarStateService.toggleIsExpanded();
    if (this.isExpanded) {
      this.isWaterAnimationActive = false;
    } else {
      this.isWaterAnimationActive = true;
    }
  }

  loadingToggled() {
    $(function () {
      "use strict";

      $(".mobile-toggle-menu").on("click", function () {
        $(".body-wrapper").addClass("toggled");
      });

      $(".toggle-icon").click(function (e: any) {
        e.preventDefault();
        if ($(".body-wrapper").hasClass("toggled")) {
          $(".body-wrapper").removeClass("toggled");
          $(".sidebar-wrapper").unbind("hover");
        } else {
          $(".body-wrapper").addClass("toggled");
          $(".sidebar-wrapper").hover(
            function () {
              $(".body-wrapper").addClass("sidebar-hovered");
            },
            function () {
              $(".body-wrapper").removeClass("sidebar-hovered");
            },
          );
        }
      });
    });
  }

  Signout() {
    if (confirm("Are you sure you want to logout?")) {
      this.timeTracker();
      this.chatService.setMessages(null);
      this.clearToken();
      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        if (this.ROLEID == "2115" || this.ROLEID == "2116")
          this.route.navigate(["/vendorlogin"]);
        else this.route.navigate(["/login"]);
      }, 500);
    }
  }

  clearToken() {
    this.CommonService.postCall("Account/ClearToken", {
      UserID: localStorage.getItem("UserId"),
    }).subscribe((res: any) => { });
  }

  menuClick() {
    $("#sidebar").toggleClass("slide");
  }

  loadMessage() {
    this.notifications = [];
    if (this.ROLEID == "1") {
      this.OPERATION = "GETNOTIFICATIONS";
    } else if (this.ROLEID == "2") {
      this.OPERATION = "TRAINERNOTIFICATIONS";
    } else if (this.ROLEID == "3") {
      this.OPERATION = "STUDENTNOTIFICATIONS";
    }

    this.CommonService.getCall(
      `Notification/GetNotification/${this.OPERATION}/${localStorage.getItem(
        "TenantCode",
      )}/${localStorage.getItem("UserId")}`,
    ).subscribe(
      (res: any) => {
        this.notification = res;
      },
      (e) => {
        // console.log(e);
      },
    );
  }

  loadNotification() {
    this.notification = [];
    this.CommonService.getCall(
      `EmsAlerts/GetNotificationsByUser/${localStorage.getItem("UserId")}`,
    ).subscribe((res: any) => {
      this.notification = res?.lstt;
      this.notificationCount = res;
    });
  }

  viewNotification(event: any) {
    this.viewNoti = [];
    this.viewNoti =
      +event == 0
        ? this.notification
        : this.notification.filter((e: any) => e.ID == event);

    this.CommonService.getCall(
      `Notification/UpdateNotification/UPDATE/${event}`,
    ).subscribe((res: any) => { });
    let payload = {
      user_id: localStorage.getItem("UserId"),
      notification_id: event,
      is_read: true,
      tnt_code: localStorage.getItem("TenantCode"),
      createdby: localStorage.getItem("UserId"),
      modifiedby: localStorage.getItem("UserId"),
    };
    this.CommonService.postCall(
      "EmsAlerts/CreateReadMessages",
      payload,
    ).subscribe((res: any) => { });
  }

  getOnlineTeachers(TenantCode: number) {
    [this.TeachersCount, this.onlineTeachers] = [0, []];
    this.CommonService.getData(
      `telecon/doctorstatus/getall/?TENANT_ID=${TenantCode}`,
    ).subscribe((res) => {
      [this.onlineTeachers, this.TeachersCount] = [res, res.length];
    });
  }

  viewMessage(event: any) {
    this.viewNoti = [];
    this.viewNoti =
      +event == 0
        ? this.notification
        : this.notification.filter((e: any) => e.ID == event);
  }

  delete(id: any, type: any, notificationid: any) {
    if (id) {
      type = 2;
    } else if (notificationid) {
      type = 1;
    }
    return;
  }

  close() {
    this.getUnViewdNotificationCount();
    this.loadMessage();
  }

  close1() {
    this.myForm.reset();
  }

  async getOldPassword() {
    this.CommonService.postCall(`Registration/GetOldPassWord`, {
      userid: localStorage.getItem("UserId"),
    }).subscribe((res: any) => {
      this.oldPassword = res.encryptedpassword;
      if (this.oldPassword) {
        this.decryptPassword(this.oldPassword);
      }

    });


  }
  async decryptPassword(oldPassword: any) {
    this.oldPassword = await this.CommonService.decryptAesGcm(oldPassword,
      this.CommonService.secretKey,
    );
  }

  passwordCheck() {
    let pControl = this.myForm.controls["password"];
    let cControl = this.myForm.controls["confirmPassword"];
    if (!pControl.value) {
      this.toastr.warning("Please enter the password");
      cControl.setValue(null);
      return;
    }
    if (pControl.value != cControl.value) {
      this.toastr.warning("New Password and Confirm Password Should be same");
      cControl.setValue(null);
    }
  }

  async ChangePass(form: any) {
    let value = form.value;

    const encryptedPassword = await this.CommonService.encryptAesGcm(
      value.password.toString(),
      this.CommonService.secretKey,
    );

    let payload = {
      userid: localStorage.getItem("UserId"),
      password: encryptedPassword,
    };

    if (this.oldPassword == value.oldPassword) {
      this.CommonService.postCall(
        `Registration/UpdateUserPassWord`,
        payload,
      ).subscribe(
        (res: any) => {
          this.toastr.success("Password Changed Successfully");
          document.getElementById("passPopupClose")?.click();
          this.Signout();
        },
        (err) => {
          this.toastr.error(err.error ? err.error : "Password Not Changed");
        },
      );
    } else {
      this.toastr.warning("Old Password is Incorrect");
    }
  }

  getUnViewdNotificationCount1() {
    return this.table.filter((m) => m.IsRead == false).length;
  }

  getUnViewdNotificationCount() {
    return this.notification?.length;
  }

  apply() {
    document.getElementById("Noti_close")?.click();
  }

  userManual() {
    window.open(
      `${environment.videoUrl}/home/userManual/Student_Process_Flow.docx`,
    );
  }

  profileNavigate(role: any) {
    let id = localStorage.getItem("UserId");
    sessionStorage.isTabsDisabled = false;
    this.CommonService.postCall("EditRegistrationByUserId", {
      CREATEDBY: id,
    }).subscribe(
      (res: any) => {
        if (role == "admin") {
          this.route.navigate(["HOME/registration/editUserRegistration"], {
            queryParams: { token: res.value, wId: 64, rId: 2071 },
          });
        } else {
          this.route.navigate(["HOME/registration/profile"]);
        }
      },
      (err) => { },
    );
  }

  viewMessages(event: any) { }
  viewNotifications(event: any) { }

  timeTracker() {
    this.startTime = localStorage.getItem("loginTime");
    let Sdate: any = new Date(this.startTime);
    const timestamp = Sdate.toLocaleTimeString();

    this.endtime = new Date();
    this.getDataDiff(Sdate, this.endtime);

    let payload = {
      loginaudit_userid: localStorage.getItem("UserId"),
      loginaudit_login_intime: timestamp,
      loginaudit_login_outtime: this.endtime.toLocaleTimeString(),
      loginaudit_login_timespent: `${this.differnceTime.hour}:${this.differnceTime.minute}:${this.differnceTime.second}`,
      loginaudit_createdby: localStorage.getItem("UserId"),
      tnt_code: localStorage.getItem("TenantCode"),
    };
    this.CommonService.postCall("LoginAudit/CreateAudit", payload).subscribe(
      (res: any) => { },
    );
  }

  getDataDiff(startDate: any, endDate: any) {
    let diff = endDate.getTime() - startDate.getTime();
    let days = Math.floor(diff / (60 * 60 * 24 * 1000));
    let hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
    let minutes =
      Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
    let seconds =
      Math.floor(diff / 1000) -
      (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    this.differnceTime = {
      day: days,
      hour: hours,
      minute: minutes,
      second: seconds,
    };
  }

  getRoles() {
    let payload = {
      USERID: localStorage.getItem("UserId"),
      TENANTCODE: localStorage.getItem("TenantCode"),
    };
    this.CommonService.postCall(
      "Registration/LoadRolesDashboard",
      payload,
    ).subscribe((res: any) => {
      this.roles = res;
    });
  }

  changeRoles(event: any) {
    let val = event.target.value;
    let payload = {
      USERID: localStorage.getItem("UserId"),
      TENANTCODE: localStorage.getItem("TenantCode"),
      ROLEID: val,
    };
    this.CommonService.postCall(
      "Registration/LoadRolesByUser",
      payload,
    ).subscribe(
      (res: any) => {
        let userData: any = res[0];
        localStorage.setItem("RoleId", btoa(val));
        sessionStorage.setItem("RoleId", btoa(val));
        localStorage.setItem("SchoolId", userData.CATEGORY_ID);
        localStorage.setItem("DepartmentId", userData.DEPARTMENT_ID);
        localStorage.setItem("TYPE", userData.TYPE);
        localStorage.setItem("RoleName", userData.ROLE_NAME);
        this.roleName = userData.ROLE_NAME;
        this.roleChange(val);
      },
      (err: any) => {
        this.toastr.error("Failed!");
      },
    );
  }

  getSchool() {
    this.CommonService.getCall(
      "Registration/GetActiveSchoolLevelList",
    ).subscribe((res: any) => {
      this.SchoolList = res;
    });
  }

  changeSchool(event: any) {
    this.CommonService.activateSpinner();
    let val = event.target.value;
    let payload = {
      UserId: localStorage.getItem("UserId"),
      SCHOOLLEVEL: val,
    };
    this.CommonService.postCall(
      "Registration/UpdateSchoolLevelId",
      payload,
    ).subscribe(
      (res: any) => {
        localStorage.setItem("schoolLevelID", val);
        this.RouteToDashboard();
        this.CommonService.deactivateSpinner();
      },
      (err: any) => {
        this.toastr.error("Failed!");
        this.CommonService.deactivateSpinner();
      },
    );
  }

  RouteToDashboard() {
    const navigationExtras: any = {
      queryParams: {
        cd: true,
        reload: "true",
        timestamp: Date.now(),
      },
      queryParamsHandling: "merge",
    };

    if (this.ROLEID == "2128") {
      this.route.navigate(["/HOME/cdeDashboard"], navigationExtras);
    } else if (this.ROLEID == "2127") {
      this.route.navigate(["/HOME/scdeDashboard"], navigationExtras);
    } else if (this.ROLEID == "2129") {
      this.route.navigate(["/HOME/qasoDashboard"], navigationExtras);
    } else if (this.ROLEID == "2145") {
      this.route.navigate(["/HOME/rdeDashboard"], navigationExtras);
    } else {
      this.route.navigate(["/HOME/dashboard"], navigationExtras);
    }
  }

  getAccessingText(): string {
    return this.SchoolLevelId == 6
      ? "You are Currently accessing Primary School Information"
      : this.SchoolLevelId == 8 ? "You are Currently accessing Senior School Information" : "You are Currently accessing Junior School Information";
  }

  roleChange(rId: any) {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `PermissionRole/GetListById/${localStorage.TenantCode}/${+rId}`,
    ).subscribe(
      (res: any) => {
        localStorage.removeItem("isApprove");
        localStorage.setItem("isApprove", btoa(JSON.stringify(res.data)));
        this.superMaduleEvent.emit(rId);
        this.route.navigate(["/HOME"], { queryParams: { req: rId } });
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      },
    );
  }

  isUrlBasedLogo(): boolean {
    return localStorage.getItem("isUrlBasedLogo") === "true";
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG and PNG files allowed");
      event.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
    };
    reader.readAsDataURL(file);
  }

  navigateToDashboard() {
    this.route.navigate([this.dashboardPath]);
  }

  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }

  submitName() {
    this.activeSpinner()
    let payload = {
      TNT_CODE: localStorage.getItem("TenantCode") || "",
      firstname: this.editData.firstname
    }
    this.CommonService.postCall("TenantRegistration/UpdateAdminNameUserprofile", payload).subscribe((res: any) => {
      document.getElementById('editModal')?.click();
      this.deactivateSpinner();

    }, (e) => {
      this.toastr.error("Failed to submit");
      this.deactivateSpinner();
    });
  }

}